import { NFeEntradaFormacaoPrecosPreviaRequest } from './nfe-entrada-formacao-precos-previa.request';

/** Prévia confirmada: o servidor recalcula e grava somente os itens e as atualizações escolhidos. */
export class NFeEntradaFormacaoPrecosAplicarRequest extends NFeEntradaFormacaoPrecosPreviaRequest {
  public identificadoresSelecionados: string[] = [];
  public isAtualizarCusto = false;
  public isAtualizarPrecoVenda = false;
  public isAtualizarMarkup = false;
  /** Confirmação de que a aplicação anterior da formação desta nota será substituída (obrigatória quando já houve). */
  public isSubstituirAplicacaoAnterior = false;
}
